export default {
  maps: {
    apiKey: ''
  },
  analytics: {
    apiKey: ''
  }
}
